export default function getResource(label, vars = []) {
    const resources = { add: 'Ajouter' };

    return resources[label];
}
